import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SiteLayoutComponent } from '@biz2x/libraries/core-utils/ui-kit';
import { AuthGuard } from './guard/auth-guard';
import { UnauthLazyGuard } from './guard/unauth-lazy.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        loadChildren: () =>
          import('@biz2x/libraries/common/login').then(
            (m) => m.LoginModule
          ),
      },
      {
        path: 'embedded',
        loadChildren: () =>
          import('@biz2x/libraries/common/dashboard').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'emdedded',
        loadChildren: () =>
          import('@biz2x/libraries/common/loan-application').then(
            (m) => m.LoanApplicationModule
          ),
      }
    ]
  },
  {
    path: '',
    component: SiteLayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('@biz2x/libraries/common/admin-dashboard').then(
            (m) => m.AdminDashboardModule
          ),
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: '',
    component: SiteLayoutComponent,
    children: [
      {
        path: 'admin',
        loadChildren: () =>
        import('@biz2x/libraries/common/admin').then(
          (m) => m.AdminModule
        ),
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: '**',
    redirectTo: '', 
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
